import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../contexts/list.manager";
import FormUsers from "../FormUsers/FormUsers";
import ListUsers from "../ListUsers/ListUsers";
import "./ConsultaUsers.css";
import { TbUserShield } from "react-icons/tb";

const ConsultaUsers = () => {
	const { lineSelected } = useListManager();
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<TbUserShield size={20} />}
					title="Usuários Cloud"
					navigate="../cadastro-Users"
					description="Buscar por Nome"
					hideAddButton={true}
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar Usuário"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					<ListUsers filters={filters} refreshKey={refreshKey} />
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormUsers user={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaUsers;
